__webpack_require__.p = "/research-tool/chat/";